export { Logotype } from './Component';
